import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import NavbarSubLinksContainer from "./NavbarSubLinksContainer";
import useWindowDimensions from "../../../hooks/useWindowSize";

const Container = styled.nav`
  padding: 10px 0 30px 30px;
  border-top: 1px solid;
  border-color: ${({ theme }) => theme.mainBorderColor};
  height: 100%;
  @media (max-width: 1550px) {
    overflow-y: auto;
  }
  
  .nav-list {
    display: flex;
    flex-direction: column;
    height: 100%;
    .nav-item {
      width: 100%;
      position: relative;
      /* &:last-child{
        margin-top: auto;
      } */

      .navlink {
        width: calc(100% - 30px);
        font-size: 16px;
        font-weight: var(--font-weight-lg);
        line-height: 18px;
        padding: 10px;
        border-radius: 10px;
        display: inline-block;
        color: ${({ theme }) => theme.mainTextColor};
        @media (max-width: 1550px) {
          font-size: 14px;
        }
        &:hover {
          background-color: ${({ theme }) => theme.secondaryBgColor};
        }
      }
      .asdas {
        background-color: ${({ theme }) => theme.secondaryBgColor};
      }

      .active {
        color: var(--color-main);
      }
    }

    .nav-item-ai{
        background: linear-gradient(90deg, #5780EA 0%, #C4698E 100%);
        width: calc(100% - 30px);
        height: 45px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        cursor: pointer;
        .asdas {
          background-color: transparent !important;
        }
        .navlink-ai{
          width: 100%;
          color: #fff;
          padding: 10px;
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-xl);
          &:hover{
            background-color: transparent !important;

          }
        }
    }
  }
`;

const Navbar = ({navItems}) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const location = useLocation().pathname;
    const {windowDimensions} = useWindowDimensions()
  
  return (
    <Container>
      {navItems?.length > 0 && (
        <ul className="nav-list">
          {navItems.filter(item =>item?.id !== 20).map((item, index) => (
            <li
            className={`nav-item ${item.name === "Akıllı Kamyoon" ? " nav-item-ai" : ""}`}
              key={item.id}
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <Link
                onClick={() => setHoveredItem(null)}
                className={
                  (item?.permission[0]?.slug.split("/")[1] === location.split("/")[1] &&
                  hoveredItem === item.id
                    ? "active navlink asdas"
                    : item?.permission[0].slug.split("/")[1] === location.split("/")[1]
                    ? "active navlink"
                    : hoveredItem === item.id
                    ? "navlink asdas"
                    : "navlink") + (item.name === "Akıllı Kamyoon" ? " navlink-ai" : "")
                }
                to={item?.permission[0]?.slug}
              >
                {item.name}
              </Link>
              {hoveredItem === item.id && item.permission.length > 1 && windowDimensions?.height > 900 && (
                <NavbarSubLinksContainer
                  parentId={item.id}
                  subLinks={item.permission}
                  onMouseEnter={() => setHoveredItem(item.id)}
                  onMouseLeave={() => setHoveredItem(null)}
                  setHoveredItem={setHoveredItem}
                  isEnd={item.id === 18}
                />
              )}
            </li>
          ))}
          {
            navItems.find(item => item.id === 20) &&
            <div className="nav-item-ai" style={{marginTop: "auto"}}>
                <Link
                  className="navlink-ai"
                  to={navItems.find(item => item.id === 20)?.permission[0]?.slug}
                >
                  {navItems.find(item => item.id === 20)?.name}
                </Link>
            </div>
          }

        </ul>
      )}
    </Container>
  );
};

export default Navbar;
